import { 
  IonModal, 
  IonHeader, 
  IonToolbar, 
  IonTitle,
  IonButtons, 
  IonButton, 
  IonIcon, 
  IonContent,
  IonList,
  IonItem,
  IonLabel
} from '@ionic/react';
import { close } from 'ionicons/icons';
import { ProfileSummary } from '../../types/profile-summary';

interface RemovedMembersModalProps {
  isOpen: boolean;
  onClose: () => void;
  removedMembers: ProfileSummary[];
}

export function RemovedMembersModal({ isOpen, onClose, removedMembers }: RemovedMembersModalProps) {
  return (
    <IonModal isOpen={isOpen} onDidDismiss={onClose}>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Removed Members</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={onClose}>
              <IonIcon icon={close} slot="icon-only" />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        {removedMembers.length === 0 ? (
          <div className="py-8 text-center text-gray-500">
            <p>No removed or suspended members</p>
          </div>
        ) : (
          <IonList>
            {removedMembers.map((member) => (
              <IonItem key={member.id}>
                <IonLabel>
                  <h2>{member.displayName}</h2>
                  {member.fullName && member.fullName !== member.displayName && (
                    <p>{member.fullName}</p>
                  )}
                </IonLabel>
              </IonItem>
            ))}
          </IonList>
        )}
      </IonContent>
    </IonModal>
  );
}

